import getFreshSideObject from "./getFreshSideObject.js";
export default function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/@popperjs+core@2.9.2/~/@popperjs/core/lib/utils/mergePaddingObject.js
// module id = 324
// module chunks = 75